import {generateClient} from 'aws-amplify/api';
import outputs from "../amplifyconfiguration.json";
import {v4 as uuidv4} from "uuid";
import {createDevelopmentPlan} from "../graphql/mutations";

const client = generateClient({
  authMode: "userPool",
  region: outputs.aws_appsync_region,
  url: outputs.aws_appsync_graphqlEndpoint,
});


/*=================  USER DB =================*/
const getUserQuery = `
    query GetUser($id: ID!) { getUser(id: $id) {
            id
            email
            developmentPlans {
                items {
                    id
                    name
                    version
                }
            }
        }
    }`;

const createUserMutation = `
    mutation CreateUser($input: CreateUserInput!) {
        createUser(input: $input) {
            id
            email
            developmentPlans {
                items {
                    id
                    name
                    version
                }
            }
        }
    }`;

export async function getUser(userId) {
  try {
    const { data } = await client.graphql({
      query: getUserQuery,
      variables: { id: userId },
      authMode: 'userPool'
    });
    console.log("user data: ", data);
    return data;
  }
  catch (error) {
    return null;
  }
}

export async function createUser(userId, email) {
  try {
    const newUserData = await client.graphql({
      query: createUserMutation,
      variables: { input: { id: userId, email: email } },
      authMode: 'userPool'
    });
    return newUserData;
  }
  catch (error) {
    return null;
  }
}


/* ==================  DEVELOPMENT PLAN DB ================= */
const getProgressQuery = (storm) =>
  ` query MyQuery($id: ID!) {
        getDevelopmentPlan(id: $id) {
          progress_${storm}
        }
      }
  `;

const getModelStatusQuery = `
  query MyQuery($id: ID!) {
      getDevelopmentPlan(id: $id) {
        modelStatus
      }
  }
`

export async function getModelProgress(devPlanID, storm = 'Aug16') {
  try {
    const result = await client.graphql({
      query: getProgressQuery(storm),
      variables: { id: devPlanID }
    });
    const progress = result.data?.getDevelopmentPlan?.[`progress_${storm}`];
    if (progress !== undefined) {
      return progress;
    }
    return -2;
  }
  catch (error) {
    return -2;
  }
}

export async function getModelStatus(devPlanID) {
  try {
    const result = await client.graphql({
      query: getModelStatusQuery,
      variables: {id: devPlanID}
    });

    const status = result.data?.getDevelopmentPlan?.[`modelStatus`];

    if (status === undefined) return null;

    const colonIndex = status.indexOf(':');
    let formattedStatus = status;
    if (colonIndex !== -1) {
      // Extract everything after the colon
      formattedStatus = status.substring(colonIndex + 1);
    }
    formattedStatus = formattedStatus.includes(' %s') ? formattedStatus.replace(' %s', '').trim() : formattedStatus;
    return formattedStatus;
  }
  catch (error) {
    return null;
  }
}

export async function createDefaultDevPlan(userID) {
  try {
    const newPlan = {
      id: uuidv4(),
      name: "myFirstDevPlan",
      version: 1,
      userID: userID,
      progress_percent: 0
    };

    const result = await client.graphql({
      query: createDevelopmentPlan,
      variables: { input: newPlan }
    });

    return result;
  }
  catch (error) {
    return null;
  }
}